export const AVAILABLE_ROLES = ["admin", "member"] as const;
export const DISABLED_PERMISSION_VALUE = "permission-disabled" as const;
export const ADMIN_ROLE = "admin" as const;
export const MEMBER_ROLE = "member" as const;

export const UDS_ADMIN_RULE_INDEX = 1 as const;
export const UDS_MEMBER_RULE_INDEX = 2 as const;

export const UDS_SCHEMAS = ["post", "news", "event", "wiki", "group"] as const;
export type UdsSchema = (typeof UDS_SCHEMAS)[number];
